const query = (id, isPreview) => `
{
    historySlider(id: "${id}", preview: ${isPreview}){
        heading
        sliderId
        slidesCollection {
          items {
            id
            image {
              altText
              imageMobile {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              imageDesktop {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
            description
            manufacturedYear
          }
        }
        slidesToShow
        timelineSlidesToShow
        backgroundColor
      }
}
`
module.exports = { query }